module.exports = __webpack_public_path__ + "static/ring_mail-234d609ca47fc92790d1a39de0375bbe.jpg";